export default "__VITE_ASSET__Cc2pe$DK__"